var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fixed pin grid gap-spacing w-screen h-screen p-spacing font-normal leading-normal text-default bg-screen",class:_vm.mode},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }